'use strict';

import { Component, Input, OnDestroy } from '@angular/core';

@Component({
    selector: 'itpx-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent {

}


// WEBPACK FOOTER //
// ./src/app/shared/components/spinner/spinner.component.ts